import React from 'react';

// const PracticeAdminHome = React.lazy(
//   () =>
//     import(
//       'src/latest/src/features/practice-admin/practice-admin-home/PracticeAdminHome'
//     ),
// );

// const PracticeAdminKpiDashboard = React.lazy(
//   () =>
//     import(
//       'src/latest/src/features/practice-admin/practice-admin-kpi-dashboard/PracticeAdminKpiDashboard'
//     ),
// );

const PracticeAdminUsers = React.lazy(
  () =>
    import(
      'src/latest/src/features/practice-admin/practice-admin-users/PracticeAdminUsers'
    ),
);

export const practiceAdminRoutes = [
  // Commenting it for now, we will need it once BE implement some more KPI's
  // {
  //   path: 'home',
  //   name: 'PracticeAdminHome',
  //   component: PracticeAdminHome,
  //   extact: true,
  // },
  // {
  //   path: 'dashboard',
  //   name: 'PracticeAdminKpiDashboard',
  //   component: PracticeAdminKpiDashboard,
  //   extact: true,
  // },
  {
    path: 'users',
    name: 'Users',
    component: PracticeAdminUsers,
    extact: true,
  },
];
